<template>
  <div class="data-field-file">
    <template v-if="url">
      <div class="file-border-wrap">
        <i class="el-icon-document file-icon"></i>
        <span class="file-name">{{ name || '文件' }}</span>
        <a class="file-download theme-text-hover"
           :href="$contextPath(url)"
           :download="name || true"
           target="_blank">
          <i class="el-icon-download"></i>
        </a>
      </div>
    </template>
    <template v-else>
      <span class="field-empty">-</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'FileField',
  props: {
    name: String,
    url: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.data-field-file {
  display: flex;
  align-items: center;

  .file-border-wrap {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 8px 12px;
    border-radius: 4px;
    background-color: #F3F5F7;
  }

  .file-icon {
    flex: none;
    font-size: 14px;
    color: #909399;
  }

  .file-name {
    flex: 1;
    margin-left: 6px;
    font-size: 13px;
    color: #606266;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .file-download {
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    font-size: 16px;
    color: #909399;
    cursor: pointer;
    transition: color 0.2s;
  }

  .field-empty {
    font-size: 13px;
    color: #909399;
  }
}
</style>
